import React, { Component } from 'react';
import styled from 'styled-components';
import { Transition, config, animated } from '@react-spring/web';
import Cookies from 'js-cookie';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var data$1 = { meta:{ forComponent:"MunicipalitySearch",
    language:"German" },
  placeholder:"Gemeindesuche",
  error:{ noResultsByZip:"Es wurde keine Gemeinde mit dieser Postleitzahl gefunden.",
    noResultsByName:"Es wurde keine Gemeinde mit diesem Namen gefunden.",
    municipalitiesNotDownloaded:"Die Gemeindeliste konnte nicht heruntergeladen werden. Die Suche steht zur Zeit nicht zur Verfügung." },
  list:{ municipalityPrefix:"Gemeinde",
    electoralDistrictPrefix:"Wahlkreis" },
  results:"{numResults, plural, =0 {Keine Resultate} one {Ein Resultat} other {# Resultate}}" };
data$1.meta;
data$1.placeholder;
data$1.error;
data$1.list;
data$1.results;

var data = { meta:{ forComponent:"MunicipalitySearch",
    language:"French" },
  label:"Cherchez par code postal ou par localité",
  placeholder:"Nom de la commune",
  error:{ noResultsByZip:"Aucune commune n'a pu être trouvée avec ce numéro postal.",
    noResultsByName:"Aucune commune n'a pu être trouvée avec ce nom.",
    municipalitiesNotDownloaded:"La liste des communes n'a pas pu être téléchargée. La recherche est actuellement indisponible." },
  list:{ municipalityPrefix:"Commune:",
    electoralDistrictPrefix:"Wahlkreis" },
  results:"{numResults, plural, =0 {Aucun résultat} one {Un résultat} other {# résultats}}" };
data.meta;
data.label;
data.placeholder;
data.error;
data.list;
data.results;

var MESSAGES = { de: data$1, fr: data };
var localStorageItemName = 'selectedMunicipalities';
var translationServiceFactory = function (messageList, locale) {
    return function (key) {
        if (key == null) {
            return '';
        }
        return (key
            .split('.')
            .reduce(function (messages, prop) { return messages[prop]; }, messageList[locale]) || 'TRANSLATED STRING NOT FOUND');
    };
};
function getDomain() {
    var url = window.location.hostname;
    url = url.replace(/(https?:\/\/)?(www.)?/i, '');
    var urlArray = url.split('.');
    url = urlArray.slice(urlArray.length - 2).join('.');
    if (url.indexOf('/') !== -1) {
        return url.split('/')[0];
    }
    return url;
}
var MunicipalityDownloadError = (function (_super) {
    __extends(MunicipalityDownloadError, _super);
    function MunicipalityDownloadError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MunicipalityDownloadError;
}(Error));
var startsWithNumber = /^\d/;
var containsOnlyLetters = /^\D+$/;
var containsFourDigits = /\d{4}/;
function showResults(results) {
    return results.length > 0;
}
var MunicipalitySearch = (function (_super) {
    __extends(MunicipalitySearch, _super);
    function MunicipalitySearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: true,
            results: [],
            value: '',
            error: null,
            municipalities: [],
        };
        _this.resetComponent = function () {
            _this.setState({
                isLoading: false,
                results: [],
                value: '',
            });
        };
        _this.filterList = function (searchTerm) {
            var results = [];
            searchTerm = searchTerm.trim();
            if (searchTerm.length > 1 && _this.state.municipalities !== null) {
                var digitsResultsArray = containsFourDigits.exec(searchTerm);
                var municipalities = _this.state.municipalities;
                if (digitsResultsArray) {
                    var digits_1 = digitsResultsArray[0];
                    results = municipalities.filter(function (municipality) { var _a; return ((_a = municipality.PLZ4) !== null && _a !== void 0 ? _a : '').toString() === digits_1; });
                    if (results.length < 1) {
                        _this.setState({ error: 'error.noResultsByZip' });
                    }
                }
                else if (startsWithNumber.test(searchTerm)) {
                    results = municipalities.filter(function (municipality) { var _a; return RegExp("^" + searchTerm).test(((_a = municipality.PLZ4) !== null && _a !== void 0 ? _a : '').toString()); });
                    if (results.length < 1) {
                        _this.setState({ error: 'error.noResultsByZip' });
                    }
                }
                else if (containsOnlyLetters.test(searchTerm)) {
                    var sanitizedSearchTerm = searchTerm.replace('.', '\\.');
                    var r_1 = RegExp(sanitizedSearchTerm, 'i');
                    var exactWordRegex_1 = RegExp("\\b" + sanitizedSearchTerm + "\\b", 'i');
                    var rankResults = function (searchTerm, arrayToSort) {
                        return arrayToSort.sort(function (a, b) {
                            var aScore = scoreResult_1(searchTerm.toLowerCase(), a.NORMGEMEINDE.toLowerCase());
                            var bScore = scoreResult_1(searchTerm.toLowerCase(), b.NORMGEMEINDE.toLowerCase());
                            return bScore - aScore;
                        });
                    };
                    var scoreResult_1 = function (searchTerm, stringToCompare) {
                        if (stringToCompare === searchTerm) {
                            return 2;
                        }
                        else if (exactWordRegex_1.test(stringToCompare)) {
                            return 1;
                        }
                        else {
                            return 0;
                        }
                    };
                    var notExactMatches = municipalities.filter(function (municipality) { return r_1.test(municipality.NORMGEMEINDE); });
                    results = rankResults(sanitizedSearchTerm, notExactMatches).slice(0, _this.props.maxResults);
                    if (results.length < 1) {
                        _this.setState({ error: 'error.noResultsByName' });
                    }
                }
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'Interactions',
                    event_action: 'input',
                    event_label: "search:for_" + searchTerm + ":results_" + results.length,
                });
            }
            return _this.removeDuplicates(results, searchTerm);
        };
        _this.handleSearchChange = function (e) {
            var value = e.currentTarget.value;
            _this.setState({ isLoading: true, value: value });
            if (value.length < 1) {
                return _this.resetComponent();
            }
            var results = _this.filterList(value);
            if (results.length > 0) {
                _this.setState({ error: null, isLoading: false, results: results });
            }
            _this.setState({ results: results, isLoading: false });
        };
        _this.sendToDataPipeline = function (plz4) {
            var BASE_URL = 'https://w.tda.io/b/votation';
            var ZIP = '?zip=' + plz4;
            var url = BASE_URL + ZIP;
            return window
                .fetch(url, {
                method: 'GET',
                mode: 'no-cors',
                credentials: 'include',
            })
                .then(function (response) {
                console.log(response);
            })
                .catch(function (error) {
                console.log(error);
            });
        };
        _this.getStoredMunicipalities = function () {
            var _a, _b;
            var munisFromLocalStorage = [];
            var munisFromCookies = [];
            try {
                var munisFromLocalStorageString = (_a = localStorage.getItem('selectedMunicipalities')) !== null && _a !== void 0 ? _a : '[]';
                munisFromLocalStorage = JSON.parse(munisFromLocalStorageString);
            }
            catch (e) {
                console.log(e);
                console.warn('🗄 localStorage of selectedMunicipalities is not available');
            }
            try {
                var munisFromCookiesString = (_b = Cookies.get('selectedMunicipalities')) !== null && _b !== void 0 ? _b : '[]';
                munisFromCookies = JSON.parse(munisFromCookiesString);
            }
            catch (e) {
                console.log(e);
                console.warn('🍪 cookies of selectedMunicipalities is not available');
            }
            var ordered = __spreadArray(__spreadArray([], __read(munisFromLocalStorage)), __read(munisFromCookies)).sort(function (a, b) {
                if (b.timestamp && a.timestamp) {
                    return b.timestamp - a.timestamp;
                }
                if (b.timestamp) {
                    return 1;
                }
                if (a.timestamp) {
                    return -1;
                }
                return 0;
            });
            return _this.deduplicateMunicipalityArray(ordered);
        };
        _this.saveToSelectedMunicipalities = function (newMuni) {
            var prevSelectedMunicipalities = _this.getStoredMunicipalities();
            var slicedArray = prevSelectedMunicipalities.slice(0, 15);
            newMuni.timestamp = Date.now();
            slicedArray.unshift(newMuni);
            console.log('domain:', getDomain());
            try {
                var newMuniArray = JSON.stringify(_this.deduplicateMunicipalityArray(slicedArray));
                localStorage.setItem(localStorageItemName, newMuniArray);
                Cookies.set(localStorageItemName, newMuniArray, {
                    expires: 365,
                    domain: getDomain(),
                });
            }
            catch (_a) {
                console.warn('🗄 localStorage is not writeable');
            }
        };
        _this.deduplicateMunicipalityArray = function (munis) {
            return __spreadArray([], __read(new Map(munis
                .slice()
                .reverse()
                .map(function (muni) {
                var _a;
                return [
                    ((_a = muni.ORTNAME) !== null && _a !== void 0 ? _a : '') +
                        muni.GDENR +
                        (_this.props.dedupe ? '' : muni.PLZ4),
                    muni,
                ];
            })).values())).reverse()
                .sort(function (a, b) {
                if (b.timestamp && a.timestamp) {
                    return b.timestamp - a.timestamp;
                }
                if (b.timestamp) {
                    return 1;
                }
                if (a.timestamp) {
                    return -1;
                }
                return 0;
            });
        };
        _this.getMunicipalitiesData = function (useLegacy) {
            if (_this.props.customMunicipalities) {
                _this.setState({
                    isLoading: false,
                    municipalities: _this.props.customMunicipalities,
                });
                return Promise.resolve(_this.props.customMunicipalities);
            }
            _this.setState({
                isLoading: true,
            });
            useLegacy && console.log('Municipality search: using legacy endpoint 👴');
            var API_BASE_URL = useLegacy
                ? 'https://interaktiv.tagesanzeiger.ch/static/gemeindesuche/'
                : 'https://atm-municipality-search.s3.eu-west-1.amazonaws.com/';
            return fetch(API_BASE_URL + (_this.props.municipalityData + ".json"))
                .then(function (res) {
                if (!res.ok) {
                    throw new MunicipalityDownloadError("Download error: " + res.status + ": " + res.statusText + ".");
                }
                return res.json();
            })
                .then(function (data) {
                _this.setState({
                    isLoading: false,
                    municipalities: data,
                });
                return Promise.resolve(data);
            })
                .catch(function (error) {
                if (!useLegacy)
                    return _this.getMunicipalitiesData(true);
                if (error instanceof MunicipalityDownloadError) {
                    console.log(error);
                    console.info('Make sure that you have the municipality and zip code data for the required year uploaded to the Interaktiv server.');
                    console.info('Read more about the data generation in the "data" directory in the project repository for the MunicipalitySearch React component.');
                    _this.setState({
                        isLoading: false,
                        error: 'error.municipalitiesNotDownloaded',
                    });
                }
                else {
                    throw error;
                }
            });
        };
        return _this;
    }
    MunicipalitySearch.prototype.removeDuplicates = function (arr, searchTerm) {
        var _this = this;
        var map = new Map();
        arr.forEach(function (v) {
            var _a, _b, _c;
            if (_this.props.dedupe) {
                map.set(((_a = v.ORTNAME) !== null && _a !== void 0 ? _a : '') + v.GDENR, v);
            }
            else {
                map.set(((_b = v.PLZ4) !== null && _b !== void 0 ? _b : '') + ((_c = v.ORTNAME) !== null && _c !== void 0 ? _c : '') + v.GDENR, v);
            }
        });
        var result = __spreadArray([], __read(map.values())).reduce(function (acc, cur) {
            var _a, _b;
            if (((_a = cur.GDENAMK) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === searchTerm.toLowerCase() ||
                ((_b = cur.ORTNAME) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === searchTerm.toLowerCase()) {
                acc[0].push(cur);
            }
            else {
                acc[1].push(cur);
            }
            return acc;
        }, [[], []])
            .flat();
        return result;
    };
    MunicipalitySearch.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.municipalityData !== this.props.municipalityData) {
            this.resetComponent();
            this.getMunicipalitiesData();
        }
    };
    MunicipalitySearch.prototype.muniToString = function (muni) {
        var _a, _b;
        return muni.GDENR + ((_a = muni.ORTNAME) !== null && _a !== void 0 ? _a : '') + ((_b = muni.PLZ4) !== null && _b !== void 0 ? _b : '');
    };
    MunicipalitySearch.prototype.componentDidMount = function () {
        var _this = this;
        this.getMunicipalitiesData().then(function (data) {
            var prevSelectedMunicipalities = _this.getStoredMunicipalities();
            if (_this.props.showLastSelectedMunicipalities &&
                prevSelectedMunicipalities.length > 0) {
                var allBfsIdsAndNames_1 = prevSelectedMunicipalities.map(function (muni) { return _this.muniToString(muni); });
                var filteredFromFetchedData = data.filter(function (muni) {
                    return allBfsIdsAndNames_1.includes(_this.muniToString(muni));
                });
                filteredFromFetchedData.sort(function (a, b) {
                    return (allBfsIdsAndNames_1.indexOf(_this.muniToString(a)) -
                        allBfsIdsAndNames_1.indexOf(_this.muniToString(b)));
                });
                var dedupedData = _this.deduplicateMunicipalityArray(filteredFromFetchedData);
                dedupedData.sort(function (a, b) {
                    return (allBfsIdsAndNames_1.indexOf(_this.muniToString(a)) -
                        allBfsIdsAndNames_1.indexOf(_this.muniToString(b)));
                });
                var muniCount = _this.props.numberOfLastSelectedMunicipalities;
                _this.setState({
                    results: dedupedData.slice(0, muniCount),
                });
            }
        });
    };
    MunicipalitySearch.prototype.render = function () {
        var _this = this;
        var _a, _b, _c;
        var _d = this.state; _d.isLoading; var value = _d.value, results = _d.results;
        var t = translationServiceFactory(MESSAGES, this.props.locale);
        var preSelectedMunicipality = (_a = this.props.selectedMunicipality) !== null && _a !== void 0 ? _a : this.state.municipalities.find(function (muni) {
            return muni.GDENR === _this.props.selectedMunicipalityId;
        });
        return (React.createElement(MunicipalitySearchContainer, { className: 'municipality-search' },
            React.createElement(InputRow, { className: 'inputRow' },
                React.createElement(FlexInput, { type: 'text', "$lessPaddingLeft": !!preSelectedMunicipality || this.props.iconOnRightSide, placeholder: this.props.placeholder || t('placeholder'), value: (_b = preSelectedMunicipality === null || preSelectedMunicipality === void 0 ? void 0 : preSelectedMunicipality.NORMGEMEINDE) !== null && _b !== void 0 ? _b : value, disabled: this.state.error === 'error.municipalitiesNotDownloaded' ||
                        !!preSelectedMunicipality, onChange: this.handleSearchChange, "$backgroundColor": this.props.inputBackgroundColor }),
                preSelectedMunicipality ? (React.createElement(Icon, { onClick: function () { var _a, _b; return (_b = (_a = _this.props).onCloseHandler) === null || _b === void 0 ? void 0 : _b.call(_a); }, "$isClickable": true, id: 'search-closing-icon', "$isRight": true },
                    React.createElement("svg", { width: '20', height: '21', viewBox: '0 0 24 25', xmlns: 'http://www.w3.org/2000/svg', fill: 'currentColor', strokeWidth: '2' },
                        React.createElement("path", { d: 'M3.9 22L2 20.1L9.6 12.5L2 4.9L3.9 3L11.5 10.6L19.1 3L21 4.9L13.4 12.5L21 20.1L19.1 22L11.5 14.4L3.9 22Z', fill: 'currentColor' })))) : (React.createElement(Icon, { "$isRight": (_c = this.props) === null || _c === void 0 ? void 0 : _c.iconOnRightSide },
                    React.createElement("svg", { width: '18', height: '18', viewBox: '0 0 18 18', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', stroke: 'currentColor', strokeWidth: '2' },
                        React.createElement("circle", { cx: '7.5', cy: '7.5', r: '6' }),
                        React.createElement("line", { x1: '11', y1: '11', x2: '17', y2: '17' }))))),
            showResults(results) && (React.createElement(Results, { className: 'results', "$backgroundColor": this.props.resultBackgroundColor }, showResults(results) && (React.createElement(Transition, { native: true, items: results, keys: function (result) { return _this.muniToString(result); }, from: { transform: 'translate(0,-20px)', opacity: 0 }, enter: { transform: 'translate(0,0px)', opacity: 1 }, config: config.gentle }, function (values, result) {
                var _a;
                return (React.createElement(animated.div, { onClick: function () {
                        _this.props.onSelectionHandler(result);
                        if (_this.props.showLastSelectedMunicipalities) {
                            _this.saveToSelectedMunicipalities(result);
                        }
                        if (_this.props.resetOnSelect) {
                            _this.resetComponent();
                        }
                    }, onKeyUp: function (e) {
                        if (e.key === 'Enter' || e.key === 'Space') {
                            _this.props.onSelectionHandler(result);
                            if (_this.props.resetOnSelect) {
                                _this.resetComponent();
                            }
                        }
                    }, className: 'result', style: values, tabIndex: 0 },
                    React.createElement(ResultHeader, { className: 'resultHeader' },
                        React.createElement(ResultPlz, { className: 'resultPlz' }, result.PLZ4),
                        ' ',
                        result.ORTNAME),
                    React.createElement(ResultMeta, { className: 'resultMeta' },
                        React.createElement(React.Fragment, null,
                            result.ORTNAME ? t('list.municipalityPrefix') : '',
                            ' ',
                            React.createElement("b", null, (_a = result.GDENAMK) !== null && _a !== void 0 ? _a : result.NORMGEMEINDE +
                                ((results.find(function (muni) {
                                    return muni !== result &&
                                        muni.NORMGEMEINDE === result.NORMGEMEINDE;
                                }) && result.KTKZ)
                                    ? ' (' + result.KTKZ + ')'
                                    : ''))))));
            }))))));
    };
    MunicipalitySearch.defaultProps = {
        municipalityData: '2021v3',
        locale: 'de',
        numberOfLastSelectedMunicipalities: 1,
        resultBackgroundColor: 'var(--site-background)',
        inputBackgroundColor: 'var(--site-background)',
        maxResults: 10,
    };
    return MunicipalitySearch;
}(Component));
var Icon = styled.i(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: ", ";\n  position: absolute;\n  top: 50%;\n  ", "\n  padding-left: 0.8em;\n  transform: translateY(-50%);\n  display: flex;\n  opacity: 0.5;\n  transition: opacity 0.5s ease-in-out;\n  animation: fromLeft 0.3s ease-in-out;\n  @keyframes fromLeft {\n    0% {\n      transform: translateY(-50%) translateX(-10px);\n      opacity: 0;\n    }\n    100% {\n      transform: translateY(-50%) translateX(0);\n    }\n  }\n  &#search-closing-icon {\n    &:hover {\n      opacity: 1;\n    }\n    animation: fromRight 0.3s ease-in-out;\n    @keyframes fromRight {\n      0% {\n        transform: translateY(-50%) translateX(10px);\n        opacity: 0;\n      }\n      100% {\n        transform: translateY(-50%) translateX(0);\n      }\n    }\n  }\n"], ["\n  cursor: ", ";\n  position: absolute;\n  top: 50%;\n  ", "\n  padding-left: 0.8em;\n  transform: translateY(-50%);\n  display: flex;\n  opacity: 0.5;\n  transition: opacity 0.5s ease-in-out;\n  animation: fromLeft 0.3s ease-in-out;\n  @keyframes fromLeft {\n    0% {\n      transform: translateY(-50%) translateX(-10px);\n      opacity: 0;\n    }\n    100% {\n      transform: translateY(-50%) translateX(0);\n    }\n  }\n  &#search-closing-icon {\n    &:hover {\n      opacity: 1;\n    }\n    animation: fromRight 0.3s ease-in-out;\n    @keyframes fromRight {\n      0% {\n        transform: translateY(-50%) translateX(10px);\n        opacity: 0;\n      }\n      100% {\n        transform: translateY(-50%) translateX(0);\n      }\n    }\n  }\n"])), function (props) { return (props.$isClickable ? 'pointer' : 'default'); }, function (props) { return (props.$isRight ? 'right: 0; padding-right: 0.8em;' : ''); });
var MunicipalitySearchContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  --border-radius: 0.3em;\n  font-size: 18px;\n  font-family: var(--font-plex);\n  @media screen and (max-width: 599px) {\n    max-width: 100%;\n  }\n  max-width: 300px;\n  width: 100%;\n  color: inherit;\n  position: relative;\n"], ["\n  --border-radius: 0.3em;\n  font-size: 18px;\n  font-family: var(--font-plex);\n  @media screen and (max-width: 599px) {\n    max-width: 100%;\n  }\n  max-width: 300px;\n  width: 100%;\n  color: inherit;\n  position: relative;\n"])));
var InputRow = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  input:focus ~ i {\n    opacity: 1;\n  }\n  .ui.input {\n    width: 100%;\n    max-width: 100%;\n    transition: all 0.5s ease-in-out;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  input:focus ~ i {\n    opacity: 1;\n  }\n  .ui.input {\n    width: 100%;\n    max-width: 100%;\n    transition: all 0.5s ease-in-out;\n  }\n"])));
var FlexInput = styled.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  // reset the default input styles\n  color: inherit;\n  background-color: ", ";\n  border: solid 1px #7e7e7e7e;\n  border-radius: var(--border-radius);\n  box-shadow: none;\n  font-size: 1em;\n  outline: none;\n  transition: all 0.3s ease-in-out;\n  padding: 0.5em;\n  padding-left: ", ";\n  margin: 0;\n  width: 100%;\n  display: flex;\n  &:disabled {\n    opacity: 0.5;\n  }\n  &::placeholder {\n    color: inherit;\n    opacity: 0.5;\n  }\n"], ["\n  // reset the default input styles\n  color: inherit;\n  background-color: ",
    ";\n  border: solid 1px #7e7e7e7e;\n  border-radius: var(--border-radius);\n  box-shadow: none;\n  font-size: 1em;\n  outline: none;\n  transition: all 0.3s ease-in-out;\n  padding: 0.5em;\n  padding-left: ",
    ";\n  margin: 0;\n  width: 100%;\n  display: flex;\n  &:disabled {\n    opacity: 0.5;\n  }\n  &::placeholder {\n    color: inherit;\n    opacity: 0.5;\n  }\n"])), function (_a) {
    var backgroundColor = _a.$backgroundColor;
    return backgroundColor;
}, function (_a) {
    var lessPaddingLeft = _a.$lessPaddingLeft;
    return lessPaddingLeft ? '1em' : '2.4em';
});
var Results = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: 0.25em;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: 0;\n  font-family: var(--font-plex);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  pointer-events: auto;\n  position: absolute;\n  background-color: ", ";\n  width: 100%;\n  border-radius: var(--border-radius);\n  @media screen and (min-width: 599px) {\n    max-width: 300px;\n  }\n  .result {\n    max-width: 100%;\n    color: currentColor;\n    padding: calc(11 / 16 * 1em) calc(14 / 16 * 1em);\n    border-radius: var(--border-radius);\n    box-shadow: 0 0 0 rgba(0, 0, 0, 0.3);\n    //border: 1px solid #007abf;\n    color: inherit;\n    line-height: 1.1em;\n    cursor: pointer;\n    transition: box-shadow 200ms ease-in-out;\n    &:hover,\n    &:focus {\n      box-shadow:\n        0 0 0.5ex rgba(0, 0, 0, 0.2),\n        0 0 0 1px #007abf inset;\n    }\n  }\n"], ["\n  margin-top: 0.25em;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: 0;\n  font-family: var(--font-plex);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  pointer-events: auto;\n  position: absolute;\n  background-color: ",
    ";\n  width: 100%;\n  border-radius: var(--border-radius);\n  @media screen and (min-width: 599px) {\n    max-width: 300px;\n  }\n  .result {\n    max-width: 100%;\n    color: currentColor;\n    padding: calc(11 / 16 * 1em) calc(14 / 16 * 1em);\n    border-radius: var(--border-radius);\n    box-shadow: 0 0 0 rgba(0, 0, 0, 0.3);\n    //border: 1px solid #007abf;\n    color: inherit;\n    line-height: 1.1em;\n    cursor: pointer;\n    transition: box-shadow 200ms ease-in-out;\n    &:hover,\n    &:focus {\n      box-shadow:\n        0 0 0.5ex rgba(0, 0, 0, 0.2),\n        0 0 0 1px #007abf inset;\n    }\n  }\n"])), function (_a) {
    var backgroundColor = _a.$backgroundColor;
    return backgroundColor;
});
var ResultHeader = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  /* font-weight: 700; */\n"], ["\n  /* font-weight: 700; */\n"])));
var ResultPlz = styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  /* opacity: 0.5; */\n  font-weight: 400;\n"], ["\n  /* opacity: 0.5; */\n  font-weight: 400;\n"])));
var ResultMeta = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  /* opacity: 0.66; */\n  font-size: 0.9em;\n"], ["\n  /* opacity: 0.66; */\n  font-size: 0.9em;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

export { MunicipalitySearch, MunicipalitySearch as default };
//# sourceMappingURL=index.js.map
